<template>
  <div
    class="flex justify-center items-center px-4 h-54 bg-black bg-opacity-30 rounded-3xl"
  >
    <span
      :class="
        index === slideNumber
          ? 'bg-dark-moderate-violet'
          : 'bg-very-dark-violet'
      "
      class="w-6 h-6 rounded-full mx-5 z-10 cursor-pointer"
      v-for="(item, index) in page"
      :key="index"
      @click="moveToSlide(index)"
    ></span>
  </div>
</template>

<script>
export default {
  props: ['page', 'slideNumber', 'moveToSlide'],
};
</script>

<style></style>
